import { Switch, Typography } from "@mui/joy";
import { currencyColumn, genericColumn, getColumnValue, numberColumn, textColumn, textareaColumn, yesNoColumn } from "./columnHelpers";

export const propertyUnitsRelationship = {
    collapsible: false,
    title: 'Units',
    tint: 'default',
    type: 'table',
    sx: {
        '--mm-card-height': 'auto',
    },
    columns: [
        // textColumn({label: 'Unit', column: 'unit'}),
        textColumn({label: 'Unit', column: 'unit', secondaryColumn: 'notes'}),
        yesNoColumn({
            label: 'Residential',
            column: 'residential',
            onChange: (object, data, setValue) => {
                console.log('ONCHAGNE CALLED');

                if(!object.residential) {
                    setValue('occupied', 0);
                }
            }
        }),
        // yesNoColumn({label: 'Occupied', column: 'occupied'}),
        yesNoColumn({
            label: 'Occupied',
            column: 'occupied',
            enabled: (object, data) => {
                return !!object.residential;
            },
        }),
        textColumn({label: 'Square Footage', column: 'square_footage', format: 'number'}), // this is a string in the db
        currencyColumn({label: 'Rent', column: 'rent'}),
        genericColumn({
            label: 'Number of Residents',
            column: 'num_residents',
            enabled: (object, data) => {
                return !!object.residential;
            },
            render: {
                show: (object) => {
                    return <Typography fontSize={'md'}>
                        {object.residential ? getColumnValue(object, 'num_residents') : 'N/A'}
                    </Typography>
                },
           },
        }),
    ],
};


export const propertyUnitsRelationshipEdit = {
    collapsible: false,
    title: 'Units',
    tint: 'default',
    type: 'table',
    sx: {
        '--mm-card-height': 'auto',
    },
    columns: [
        // textColumn({label: 'Unit', column: 'unit'}),
        textColumn({label: 'Unit', column: 'unit', secondaryColumn: 'notes'}),
        genericColumn({
            label: 'Residential',
            type: 'custom',
            render: {
                edit: ({rowIndex, row, data, setRowValue}) => {
                    const isResidential = !!row.residential;
                    const isOccupied = !!row.occupied;
                    return (<>
                        <Typography sx={{userSelect: 'none',}} component="label" startDecorator={
                          <Switch
                            // key={cellIndex}
                            variant={'solid'}
                            onChange={(e) => {
                              setRowValue(rowIndex, 'residential', isResidential ? 0 : 1)
                              if(!isResidential) {
                                setRowValue(rowIndex, 'occupied', 0)
                              }
                            }}
                            checked={isResidential}
                          />
                        }>
                          Residential
                        </Typography>
                        <Typography sx={{userSelect: 'none', mt: 0.5}} component="label" startDecorator={
                          <Switch
                            // key={cellIndex}
                            variant={'solid'}
                            disabled={!isResidential}
                            onChange={(e) => {
                              setRowValue(rowIndex, 'occupied', isOccupied ? 0 : 1)
                            }}
                            checked={isResidential && isOccupied}
                            sx={theme => ({
                                '--variant-solidDisabledBg': 'var(--joy-palette-neutral-300)',
                                '--variant-solidDisabledColor': 'var(--joy-palette-neutral-50)',
                            })}
                          />
                        }>
                          Occupied
                        </Typography>
                    </>)
                },
            },
        }),
        /*
        yesNoColumn({
            label: 'Residential',
            column: 'residential',
            onChange: (object, data, setValue) => {
                console.log('ONCHAGNE CALLED');

                if(!object.residential) {
                    setValue('occupied', 0);
                }
            }
        }),
        yesNoColumn({
            label: 'Occupied',
            column: 'occupied',
            enabled: (object, data) => {
                return !!object.residential;
            },
        }),
        */
        textColumn({label: 'Square Footage', column: 'square_footage', format: 'number'}), // this is a string in the db
        currencyColumn({label: 'Rent', column: 'rent'}),
        genericColumn({
            label: 'Number of Residents',
            column: 'num_residents',
            enabled: (object, data) => {
                return !!object.residential;
            },
            render: {
                show: (object) => {
                    return <Typography fontSize={'md'}>
                        {object.residential ? getColumnValue(object, 'num_residents') : 'N/A'}
                    </Typography>
                },
           },
        }),
        textareaColumn({
            label: 'Notes',
            column: 'notes',
        }),
    ],
};
